import { useUser } from "@tm/context-distribution"
import { useLocalization } from "@tm/localization"
import { useActions } from "@tm/morpheus"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { getCountryDescriptionByCountryCode } from "@tm/utils"
import { useCallback, useEffect, useMemo } from "react"
import GeneralCustomerForm from "@bundles/damage-calculation-dat/components/_shared/GeneralCustomerFields"
import { MainActions, fieldsSelector } from "../../main/business"
import { getGlassCustomerSchema } from "../business/helpers"

export const customerFieldsSelector = createSelector(
    fieldsSelector,
    ({ titleType, firstName, lastName, companyName, street, streetNo, zip, city, country, registrationNos }) => ({
        titleType,
        firstName,
        lastName,
        companyName,
        street,
        streetNo,
        zip,
        city,
        country,
        registrationNos,
    })
)

export default function CustomerInfoFields() {
    const { translateText } = useLocalization()
    const actions = useActions(MainActions, "updateFieldValue", "initCustomer", "setValidateFields")
    const user = useUser()

    const fields = useSelector(customerFieldsSelector)
    const fieldsSchema = useMemo(() => getGlassCustomerSchema(translateText, fields?.titleType), [translateText])

    useEffect(() => {
        user?.userContext && !fields.country?.length && actions.initCustomer(getCountryDescriptionByCountryCode(user?.userContext!, translateText))
    }, [fields.country])

    const onHandleUpdateValue = useCallback(
        (path: string, value: string) => {
            actions?.updateFieldValue(path, value)
        },
        [actions]
    )

    const handleFormValid = useCallback(
        (isValid: boolean) => {
            actions.setValidateFields("customerValid", isValid)
        },
        [actions]
    )

    return <GeneralCustomerForm onFormValid={handleFormValid} schema={fieldsSchema} fields={fields} onUpdateFieldValue={onHandleUpdateValue} />
}
